import { Conversation } from "@twilio/conversations";
import { Dispatch } from "redux";

import { EscalationStatus } from "../../definitions";
import { ACTION_UPDATE_CONVERSATION_STATE, ACTION_UPDATE_ESCALATION_STATUS } from "../actionTypes";

export const initConversationListener = (conversation: Conversation, dispatch: Dispatch) => {
    conversation.addListener("updated", async ({ conversation: updatedConversation, updateReasons }) => {
        if (updateReasons?.includes("attributes")) {
            const status = await checkTaskStatus(conversation);
            dispatch({
                type: ACTION_UPDATE_ESCALATION_STATUS,
                payload: { escalationStatus: status }
            });
        }

        if (updateReasons?.includes("state")) {
            dispatch({
                type: ACTION_UPDATE_CONVERSATION_STATE,
                payload: { conversationState: updatedConversation?.state?.current }
            });
        }
    });

    conversation.addListener("participantJoined", async () => {
        const status = await checkTaskStatus(conversation);
        dispatch({
            type: ACTION_UPDATE_ESCALATION_STATUS,
            payload: { escalationStatus: status }
        });
    });
};

const checkTaskStatus = async (conversation: Conversation): Promise<EscalationStatus> => {
    if (await conversation?.getParticipantsCount() > 1) {
        return EscalationStatus.ATTENDED;
    }

    if ((conversation?.attributes as { isEscalated: boolean } | undefined)?.isEscalated) {
        return EscalationStatus.IN_QUEUE;
    }

    return EscalationStatus.IN_FLOW;
}